import styled from 'styled-components';
import { theme } from '../../../styles/theme';

const Container = styled.div`
  padding: 32px 16px 16px;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  color: ${theme.colors.secondary800};
`;

const EmptyConversationThreads = () => (
  <Container>
    There are no comments
    <br />
    on this dashboard
  </Container>
);

export default EmptyConversationThreads;
